import React from 'react';
import Chip from '@mui/material/Chip';

const Label = ({ color, name, isMini = false }) => {
  const statusColorMap = {
    invited: '#007bff',
    active: '#28a745',
    inactive: '#6c757d',
    pending: '#ffc107',
    suspended: '#dc3545',
    'invite-accepted': '#17a2b8',
    'delete-requested': '#dc3545',
    system: '#6c757d',
    org: '#1b3f87',
    project: '#0f766e',
  };

  const finalColor = color || statusColorMap[name] || '#1b3f87';

  return (
    <Chip
      label={name?.toUpperCase()}
      size="small"
      sx={{
        backgroundColor: finalColor,
        color: 'white',
        fontWeight: 500,
        fontSize: isMini ? '10px' : '12px',
        borderRadius: '4px',
        height: isMini ? '16px' : '20px',
        '& .MuiChip-label': {
          px: isMini ? 0.75 : 1,
        },
      }}
    />
  );
};

export default Label;